import React from 'react'
import ReactDOM from 'react-dom';
import SelectModalTabPane from './tabPane'

export default class SelectModalTabs extends React.Component {
  constructor(props) {
    super(props)
    this.activeTab = this.props.children[0]
    this.refList = [];
    this.state = {
      activeTabKey: '',
      barWidth: 0,
      translate: 0
    }
  }

  static defaultProps = {
    prefixCls: 'mkui-modal-tabs'
  }

  componentDidMount(){
    this.setPosition(0)
  }

  setPosition(idx){
    let activeTabEle = this.refList[idx].current
    this.setState({
      barWidth: activeTabEle.clientWidth,
      translate: activeTabEle.offsetLeft,
      activeTabKey: this.activeTab.key
    })
  }

  onClick(tab, idx){
    if(tab.key !== this.state.activeTabKey){
      const {onChange} = this.props
      this.activeTab = tab
      this.setPosition(idx)
      if(onChange){
        onChange(tab)
      }
    }
  }

  render(){
    this.refList = []
    let {prefixCls, children, withResult} = this.props
    let {activeTabKey, barWidth, translate} = this.state
    let tabIndex = 0
    let tabTitleList =  children.map((tab, index)=>{
      let activeCls = ''
      if(tab.key === activeTabKey){
        tabIndex = index
        activeCls = 'active'
      }
      let ref = React.createRef()
      this.refList.push(ref)
      return <div className={`tab ${activeCls}`} key={`tab-title-${index}`} onClick={()=>{this.onClick(tab, index)}} ref={ref}>{tab.props.title}</div>
    })
    return (
      <div className={prefixCls +(withResult?' with-result':'')}>
        <div className={`${prefixCls}-tab-names`}>
          {tabTitleList}
          <div className={`${prefixCls}-tab-line-bar`}
               style={{transform: `translate(${translate}px, 0)`,width: `${barWidth}px`}}/>
        </div>
        <div className={`${prefixCls}-tab-contents`} style={{marginLeft: `${-tabIndex * 100}%`, width: `${children.length * 100}%`}}>{children}</div>
      </div>
    );
  }
}

SelectModalTabs.TabPane = SelectModalTabPane
